export const PDF_DOM_CAPTURE_CLASS = "pdf-dom-capture-active";

export async function runDuringPdfDomCapture(fn) {
  const root = document.documentElement;
  root.classList.add(PDF_DOM_CAPTURE_CLASS);
  await new Promise((resolve) =>
    requestAnimationFrame(() => requestAnimationFrame(resolve))
  );
  try {
    return await fn();
  } finally {
    root.classList.remove(PDF_DOM_CAPTURE_CLASS);
  }
}
